import moment from "moment";

import { type Table, type Column } from "@devexpress/dx-react-grid";
import { type MMMClientCycleBase } from "@north-beam/nb-common";

export const formatDates = (dateRange: MMMClientCycleBase["date_range"]) =>
  `${moment(dateRange.start_date).format("MMM D, YYYY")} - ${moment(
    dateRange.end_date,
  ).format("MMM D, YYYY")}`;

export const TABLE_COLUMNS: Column[] = [
  {
    name: "name",
    title: "MEDIA PLANS",
    getCellValue: (row) => row.name || formatDates(row.date_range),
  },
  {
    name: "date_range",
    title: "DATES",
    getCellValue: (row) => formatDates(row.date_range),
  },
  {
    name: "channels",
    title: "CHANNELS",
    getCellValue: (row) => row.spend_model_data_columns?.length ?? 0,
  },
  { name: "kpis", title: "KPIs", getCellValue: (row) => row.kpis?.length ?? 0 },
  { name: "status", title: "STATUS" },
  { name: "delete", title: "DELETE" },
];

export const TABLE_COLUMN_EXTENSIONS: Table.ColumnExtension[] = [
  { columnName: "name", width: "30%" },
  { columnName: "date_range", width: "17%" },
  { columnName: "channels", width: "auto", align: "right" },
  { columnName: "kpis", width: "auto", align: "right" },
  { columnName: "status", width: "90px" },
  { columnName: "delete", width: "auto", align: "left" },
];
